module.exports = __webpack_public_path__ + "static/media/p10.d912d808.png";